(function () {
  'use strict';

  angular.module('app').component('vehiclePage', vehicleDetailComponent());

  function vehicleDetailComponent() {
    return {
      controller: VehicleDetailCrtl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/vehicles/vehicle-page.component.html',
    };
  }

  VehicleDetailCrtl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'VehicleService',
    'LanguageService',
  ];

  function VehicleDetailCrtl(
    $location,
    $routeParams,
    AbilityService,
    VehicleService,
    LanguageService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.permissions = {
      canCreate: AbilityService.can('create_vehicle_accountadmin'),
    };

    // private properties
    // -----------------------
    let itemId = $routeParams.id;

    // Initializers
    getAdditionalLanguages();

    // public methods
    // -----------------------
    vm.onSavedItem = function (item) {
      $location.path(`/vehicles/${item.id}`);
    };

    vm.onCanceledItem = function () {
      $location.path('/vehicles');
    };

    // private methods
    // -----------------------
    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getVehicle();
      });
    }

    function getVehicle() {
      if (itemId) {
        //Edit
        vm.loadingItem = true;
        VehicleService.getVehicle(itemId, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }
  }
})();
